document.addEventListener('DOMContentLoaded', () => {
  const menuElement = document.querySelector('#menu');
  const menuToogleElement = document.querySelector('#mobile-menu-toggle');
  const searchButtonElement = document.querySelector('#mobile_search_submit_btn svg');
  const searchWrapperElement = document.querySelector('#mobile_search_submit_btn .search-form__wrapper');

  searchButtonElement.addEventListener('click', (e) => {
    e.stopPropagation();
    menuElement.style.display = 'none';
    menuToogleElement.classList.remove('opened');
    const searchSuggestionElement = document.querySelector('#boost-pfs-search-suggestion-mobile');
    searchSuggestionElement.style.display = 'none';
    const searchInputElement = document.querySelector('#boost-pfs-search-box-0');
    searchInputElement.addEventListener('keydown', (e) => {
      e.target.focus();
      document.querySelector('.boost-pfs-enable-instant-search .boost-pfs-search-suggestion-mobile-top-panel form input').click()
    });
  });

  menuToogleElement.addEventListener('click', () => {
    searchWrapperElement.style.display = 'none';
  });
});
